import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { PAGES as ROOT_PAGES } from '@utils/constants';
import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/mdi/book-open-page-variant-outline';

const routes: RouteRecordRaw[] = [
	{
		path: '/knowledge-base',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			isAllowed: ({ canAccessKnowledgeBase }) => canAccessKnowledgeBase || ROOT_PAGES.MODULES,
			documentTitle: 'Knowledge base',
			title: 'Knowledge base',
		},
	},
];

/** Not built here: motorway/mw-knowledge-base, loaded at runtime as a Module Federation remote. */
export const KNOWLEDGE_BASE_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.HOME },
	title: 'Knowledge base',
	description: 'Code-sourced guide to the seller-to-dealer platform',
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessKnowledgeBase }) => canAccessKnowledgeBase,
	routes,
};
